// extracted by mini-css-extract-plugin
export var banner = "_oh-0";
export var settingRow = "_oh-2";
export var titleIcon = "_oh-1";